namespace HA.Core.Controller.Page {
    export class ResultListController extends Controller {

    }
}
